<div class="flex flex-row"  >
  <div class="group-box" [ngClass] = "{'orange': item.cells[fieldDefinition.key].value==='CIT',
      'violet': item.cells[fieldDefinition.key].value==='CbC',
      'green': item.cells[fieldDefinition.key].value==='TP',
      'blue': item.cells[fieldDefinition.key].value==='VAT'}">
  </div>

  <span>
  {{item.cells[fieldDefinition.key].displayText}}
</span>
</div>

